import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import instance from "../instance";
import { formatDate } from "./Customers/utils";
import { getPaymentDateStyle } from "./Customers/styles";

const MonthlyReport = () => {
  const [reportData, setReportData] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        const response = await instance.get("monthly/report");
        const data = response.data;
        setReportData(data);

        // حساب الإجماليات الشهرية
        const monthlyTotals = data.reduce((acc, item) => {
          if (item.PaymentDate) {
            const monthYear = new Date(item.PaymentDate).toLocaleString(
              "default",
              { year: "numeric", month: "short" }
            );
            if (!acc[monthYear]) {
              acc[monthYear] = {
                PaymentCount: 0,
                TotalPrice: 0,
                PaymentDate: item.PaymentDate,
              };
            }
            acc[monthYear].PaymentCount += item.PaymentCount || 0;
            acc[monthYear].TotalPrice += item.TotalPrice || 0;
          }
          return acc;
        }, {});

        const monthlyArray = Object.values(monthlyTotals);

        setMonthlyData(monthlyArray);
      } catch (error) {
        console.error("Error fetching the report data", error);
      }
    };

    fetchReportData();
  }, []);

  const handleDailyRowClick = (date) => {
    navigate("/", { state: { date: date } });
  };

  const handleMonthlyRowClick = (date) => {
    const selectedDate = new Date(date);
    const firstDayOfMonth = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      1
    );
    const lastDayOfMonth = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth() + 1,
      0
    );

    navigate("/", {
      state: {
        startDate: firstDayOfMonth.toISOString().split("T")[0],
        endDate: lastDayOfMonth.toISOString().split("T")[0],
      },
    });
  };

  return (
    <div>
      <header>
        <h1>Report</h1>
      </header>

      <main>
        <button onClick={() => navigate("/")} className="button">
          ← Main
        </button>
        <div>
          <div style={{ marginBottom: "2rem" }}>
            <h2>Daily </h2>
            <table>
              <thead>
                <tr className="admin-row">
                  <th>Date</th>
                  <th>Count</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {reportData.map((item, index) =>
                  item.PaymentDate &&
                  item.PaymentCount > 0 &&
                  item.TotalPrice !== null ? (
                    <tr
                      key={index}
                      onClick={() => handleDailyRowClick(item.PaymentDate)}
                      style={getPaymentDateStyle(item.PaymentDate)}
                      className="admin-row"
                    >
                      <td>{formatDate(item.PaymentDate)}</td>
                      <td>{item.PaymentCount}</td>
                      <td>{item.TotalPrice.toFixed(0)}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </table>
          </div>
          <div>
            <h2>Monthly</h2>
            <table>
              <thead>
                <tr className="admin-row">
                  <th>Month</th>
                  <th>Count</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {monthlyData.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => handleMonthlyRowClick(item.PaymentDate)}
                    className="admin-row"
                  >
                    <td>
                      {new Date(item.PaymentDate).toLocaleString("default", {
                        year: "numeric",
                        month: "short",
                      })}
                    </td>
                    <td>{item.PaymentCount}</td>
                    <td>{item.TotalPrice.toFixed(0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div>
            <table className="TOTAL">
              <thead></thead>
              <tbody>
                <tr
                  style={{
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  <td>
                    <strong>Total</strong>
                  </td>
                  <td>
                    {monthlyData.reduce(
                      (acc, item) => acc + (item.PaymentCount || 0),
                      0
                    )}
                  </td>
                  <td>
                    {monthlyData
                      .reduce((acc, item) => acc + (item.TotalPrice || 0), 0)
                      .toFixed(0)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default MonthlyReport;
